import { Link } from "react-router-dom";

const BADGES = ["Ücretsiz Keşif", "Hızlı Teslim", "Kalite Garantisi", "Osmaniye & Çevresi"];

const CTASection = () => (
  <section className="relative py-32 bg-[#E6A800] overflow-hidden">
    <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none select-none">
      <span className="font-head font-black uppercase text-white/[0.04] text-[18vw] leading-none whitespace-nowrap">
        VİP REKLAM
      </span>
    </div>

    <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
      <div className="anim-scale">
        <div className="inline-flex items-center gap-2 bg-white/15 px-4 py-2 mb-10">
          <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
          <span className="font-head font-700 uppercase text-white text-xs tracking-[0.2em]">
            Ücretsiz Keşif &amp; Teklif
          </span>
        </div>

        <h2 className="font-head font-black uppercase text-white text-6xl md:text-7xl lg:text-8xl leading-[0.88] mb-4">
          Projenizi
        </h2>
        <h2 className="font-head font-black uppercase text-white/35 text-6xl md:text-7xl lg:text-8xl leading-[0.88] mb-12">
          Hayata Geçirelim
        </h2>

        <p className="text-white/70 text-sm max-w-sm mx-auto mb-12 leading-relaxed">
          Osmaniye ve çevresinde ücretsiz keşif yapıyoruz. 24 saat içinde
          detaylı teklif iletiyoruz. Hemen arayın, hemen çözüm!
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <a
            href="tel:+905511830918"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-[#E6A800] font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap hover:bg-gray-50 tr group"
          >
            <i className="ri-phone-fill text-sm" />
            +90 551 183 09 18
          </a>
          <a
            href="https://wa.me/905511830918"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#25D366]/20 border border-[#25D366]/40 text-white font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap hover:bg-[#25D366]/35 tr"
          >
            <i className="ri-whatsapp-line text-sm" />
            WhatsApp
          </a>
          <Link
            to="/iletisim"
            className="inline-flex items-center gap-3 px-8 py-4 btn-outline-light font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-sm" />
            Mesaj Gönder
          </Link>
        </div>

        <div className="flex flex-wrap justify-center gap-8">
          {BADGES.map((b) => (
            <span
              key={b}
              className="flex items-center gap-2 text-white/60 text-xs font-head font-600 uppercase tracking-wider"
            >
              <i className="ri-check-line text-white/80" />
              <span>{b}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default CTASection;